"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEntity = void 0;
const AppDto_1 = require("./AppDto");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const ClientEntity_1 = require("../clients/ClientEntity");
const ClientDto_1 = require("../clients/ClientDto");
const validators_2 = require("../GS/validators");
const INDEX_NOT_FOUND = -1;
const MYSQL_TEXT_MAX_LENGTH = 65535;
class AppEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, app) {
        super();
        this._requiredFieldsSetStatus = {
            name: false,
            bundleIdentifier: false,
            beaconUuid: false,
            analyticsReportEmail: false,
            clientId: false
        };
        this._dependencies = dependencies;
        if (app === undefined) {
            this._dto = new AppDto_1.AppDto();
        }
        else if (app instanceof AppDto_1.AppDto) {
            this._dto = new AppDto_1.AppDto(app);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (app instanceof AppEntity) {
            this._dto = new AppDto_1.AppDto(app._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AppDto_1.AppDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getBundleIdentifier() {
        return this._dto.bundleIdentifier;
    }
    setBundleIdentifier(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("bundleIdentifier");
        this._requiredFieldsSetStatus.bundleIdentifier = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("bundleIdentifier", "Bundle Identifier is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("bundleIdentifier", `Bundle Identifier has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.bundleIdentifier) {
            return;
        }
        this._dto.bundleIdentifier = _untrustedValue;
        this._setIsDirty(true);
    }
    getTwitterConsumerKey() {
        return this._dto.twitterConsumerKey;
    }
    setTwitterConsumerKey(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("twitterConsumerKey");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("twitterConsumerKey", `Twitter Consumer Key has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.twitterConsumerKey) {
            return;
        }
        this._dto.twitterConsumerKey = _untrustedValue;
        this._setIsDirty(true);
    }
    getTwitterConsumerSecret() {
        return this._dto.twitterConsumerSecret;
    }
    setTwitterConsumerSecret(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("twitterConsumerSecret");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("twitterConsumerSecret", `Twitter Consumer Secret has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.twitterConsumerSecret) {
            return;
        }
        this._dto.twitterConsumerSecret = _untrustedValue;
        this._setIsDirty(true);
    }
    getClassification() {
        return this._dto.classification;
    }
    setClassification(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("classification");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("classification", `Classification has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.classification) {
            return;
        }
        this._dto.classification = _untrustedValue;
        this._setIsDirty(true);
    }
    getFacebookAppId() {
        return this._dto.facebookAppId;
    }
    setFacebookAppId(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("facebookAppId");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("facebookAppId", `Facebook App Id has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.facebookAppId) {
            return;
        }
        this._dto.facebookAppId = _untrustedValue;
        this._setIsDirty(true);
    }
    getAppStoreAppId() {
        return this._dto.appStoreAppId;
    }
    setAppStoreAppId(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("appStoreAppId");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("appStoreAppId", `App Store App Id has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.appStoreAppId) {
            return;
        }
        this._dto.appStoreAppId = _untrustedValue;
        this._setIsDirty(true);
    }
    getAppStoreIconUrl() {
        return this._dto.appStoreIconUrl;
    }
    setAppStoreIconUrl(untrustedValue) {
        const maxLength = 160;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("appStoreIconUrl");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("appStoreIconUrl", `App Store Icon Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.appStoreIconUrl) {
            return;
        }
        this._dto.appStoreIconUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getBeaconUuid() {
        return this._dto.beaconUuid;
    }
    setBeaconUuid(untrustedValue) {
        const maxLength = 36;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("beaconUuid");
        this._requiredFieldsSetStatus.beaconUuid = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("beaconUuid", "Beacon UUID  is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("beaconUuid", `Beacon UUID has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.beaconUuid) {
            return;
        }
        this._dto.beaconUuid = _untrustedValue;
        this._setIsDirty(true);
    }
    getAnalyticsReportEmail() {
        return this._dto.analyticsReportEmail;
    }
    setAnalyticsReportEmail(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("analyticsReportEmail");
        this._requiredFieldsSetStatus.analyticsReportEmail = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("analyticsReportEmail", "Analytics Report Email is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("analyticsReportEmail", `Analytics Report Email has exceeded the maximum length (${maxLength} chr).`));
        }
        else {
            const invalidEmails = _untrustedValue.split(",")
                .filter((email) => !validators_2.isEmail(email));
            if (invalidEmails.length > 0) {
                this.addError(new ValidationError_1.ValidationError("analyticsReportEmail", "One or more Analytics Report Email are invalid. " +
                    `("${invalidEmails.join('", "')}")`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.analyticsReportEmail) {
            return;
        }
        this._dto.analyticsReportEmail = _untrustedValue;
        this._setIsDirty(true);
    }
    getWelcomeScreenTitle() {
        return this._dto.welcomeScreenTitle;
    }
    setWelcomeScreenTitle(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("welcomeScreenTitle");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("welcomeScreenTitle", `Welcome Screen Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.welcomeScreenTitle) {
            return;
        }
        this._dto.welcomeScreenTitle = _untrustedValue;
        this._setIsDirty(true);
    }
    getWelcomeScreenText() {
        return this._dto.welcomeScreenText;
    }
    setWelcomeScreenText(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("welcomeScreenText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("welcomeScreenText", `Welcome Screen Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.welcomeScreenText) {
            return;
        }
        this._dto.welcomeScreenText = _untrustedValue;
        this._setIsDirty(true);
    }
    getChooseALocationScreenTitle() {
        return this._dto.chooseALocationScreenTitle;
    }
    setChooseALocationScreenTitle(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("chooseALocationScreenTitle");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("chooseALocationScreenTitle", `ChooseA Location Screen Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.chooseALocationScreenTitle) {
            return;
        }
        this._dto.chooseALocationScreenTitle = _untrustedValue;
        this._setIsDirty(true);
    }
    getHomeScreenTitle() {
        return this._dto.homeScreenTitle;
    }
    setHomeScreenTitle(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("homeScreenTitle");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("homeScreenTitle", `Home Screen Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.homeScreenTitle) {
            return;
        }
        this._dto.homeScreenTitle = _untrustedValue;
        this._setIsDirty(true);
    }
    getLoyaltyRewardsProgramType() {
        return this._dto.loyaltyRewardsProgramType;
    }
    setLoyaltyRewardsProgramType(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("loyaltyRewardsProgramType");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("loyaltyRewardsProgramType", `Loyalty Rewards Program Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.loyaltyRewardsProgramType) {
            return;
        }
        this._dto.loyaltyRewardsProgramType = _untrustedValue;
        this._setIsDirty(true);
    }
    getLoyaltyRewardsTermsAndConditions() {
        return this._dto.loyaltyRewardsTermsAndConditions;
    }
    setLoyaltyRewardsTermsAndConditions(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("loyaltyRewardsTermsAndConditions");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("loyaltyRewardsTermsAndConditions", `Loyalty Rewards Terms and Conditions has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.loyaltyRewardsTermsAndConditions) {
            return;
        }
        this._dto.loyaltyRewardsTermsAndConditions = _untrustedValue;
        this._setIsDirty(true);
    }
    getTitleFor700CreditScreen() {
        return this._dto.titleFor700CreditScreen;
    }
    setTitleFor700CreditScreen(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("titleFor700CreditScreen");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("titleFor700CreditScreen", `Title for 700 Credit Screen has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.titleFor700CreditScreen) {
            return;
        }
        this._dto.titleFor700CreditScreen = _untrustedValue;
        this._setIsDirty(true);
    }
    getTermsAndConditionsFor700Credit() {
        return this._dto.termsAndConditionsFor700Credit;
    }
    setTermsAndConditionsFor700Credit(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("termsAndConditionsFor700Credit");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("termsAndConditionsFor700Credit", `Terms and Conditions for 700 Credit has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.termsAndConditionsFor700Credit) {
            return;
        }
        this._dto.termsAndConditionsFor700Credit = _untrustedValue;
        this._setIsDirty(true);
    }
    getPrivacyPolicyFor700Credit() {
        return this._dto.privacyPolicyFor700Credit;
    }
    setPrivacyPolicyFor700Credit(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("privacyPolicyFor700Credit");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("privacyPolicyFor700Credit", `Privacy Policy for 700 Credit has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.privacyPolicyFor700Credit) {
            return;
        }
        this._dto.privacyPolicyFor700Credit = _untrustedValue;
        this._setIsDirty(true);
    }
    getAskForSsnInCaseOfNoHitFor700Credit() {
        return this._dto.askForSsnInCaseOfNoHitFor700Credit;
    }
    setAskForSsnInCaseOfNoHitFor700Credit(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("askForSsnInCaseOfNoHitFor700Credit", "Ask for SSN in case of No Hit for 700 Credit is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("askForSsnInCaseOfNoHitFor700Credit", "Ask for SSN in case of No Hit for 700 Credit is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.askForSsnInCaseOfNoHitFor700Credit) {
            return;
        }
        this.clearError("askForSsnInCaseOfNoHitFor700Credit");
        this._dto.askForSsnInCaseOfNoHitFor700Credit = _untrustedValue;
        this._setIsDirty(true);
    }
    getExtraGanAccountIds() {
        return this._dto.extraGanAccountIds;
    }
    setExtraGanAccountIds(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("extraGanAccountIds");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("extraGanAccountIds", `Bundle Identifier has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.extraGanAccountIds) {
            return;
        }
        this._dto.extraGanAccountIds = _untrustedValue;
        this._setIsDirty(true);
    }
    getClient() {
        if (this._dto.clientId === undefined) {
            return undefined;
        }
        if (this._dto.client === undefined) {
            throw new Error("Cannot call getClient without first loading the App Version.");
        }
        if (!this._clientEntity && this._dto.client) {
            this._clientEntity = new ClientEntity_1.ClientEntity(this._dependencies, this._dto.client);
        }
        return this._clientEntity;
    }
    getClientId() {
        return this._dto.clientId;
    }
    setClient(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof ClientEntity_1.ClientEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof ClientDto_1.ClientDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setClientId(untrustedId);
        if (this.hasError("clientId")) {
            return;
        }
        if (untrustedValue instanceof ClientEntity_1.ClientEntity) {
            this._clientEntity = untrustedValue;
        }
    }
    setClientId(untrustedValue) {
        let _untrustedValue;
        this.clearError("clientId");
        this._requiredFieldsSetStatus.clientId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("clientId", "Client Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("clientId", "Client is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.clientId) {
            return;
        }
        this._dto.clientId = _untrustedValue;
        delete this._clientEntity;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.appDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("App is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.appDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.appDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("App cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.appDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AppEntity = AppEntity;
//# sourceMappingURL=AppEntity.js.map